import { useRouter } from 'next/router';
import { QueryResponseType } from 'pages/api/get-charge-packages';
import { useEffect, useState } from 'react';
import { localeToPrismicLocale } from 'utils/i18n';

export const useChargePackageData = () => {
  const router = useRouter();
  const locale = localeToPrismicLocale(router.locale);
  const [chargePackageData, setChargePackageData] =
    useState<QueryResponseType>();

  useEffect(() => {
    const fetchData = async () => {
      const fetchUrl = `/api/get-charge-packages?lang=${locale}`;
      const res = await fetch(fetchUrl);
      const { data }: { data: QueryResponseType } = await res.json();

      setChargePackageData(data);
    };
    fetchData();
  }, []);

  return {
    chargePackageData,
  };
};
